import { useState } from 'react'

import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogProps,
  DialogTitle,
  SubmitButton,
} from '@fortem-monorepo/react-ui'

import { RollRiskForm } from '@/components/forms/RollRiskForm/RollRiskForm'
import { RollRiskFormFields } from '@/components/forms/RollRiskForm/RollRiskFormFields'

export interface RollRiskModalProps extends DialogProps {}

export const RollRiskModal: React.FC<RollRiskModalProps> = ({ open, onOpenChange }) => {
  const [wantsToRollRisk, setWantsToRollRisk] = useState(false)

  return (
    <Dialog
      open={open}
      onOpenChange={(val) => {
        onOpenChange?.(val)
        setWantsToRollRisk(false)
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Roll Risk</DialogTitle>
          <DialogDescription>
            Roll the Risk for date T. This will copy the data from date T-1.
          </DialogDescription>
        </DialogHeader>
        <RollRiskForm>
          {({ formState: { isValid, isSubmitting }, getValues }) => {
            return (
              <div className={'space-y-6'}>
                <RollRiskFormFields inputsDisabled={wantsToRollRisk} />
                <div className="flex items-center gap-2">
                  {wantsToRollRisk ? (
                    <div className={'flex flex-col gap-4 border border-red-400 p-4 rounded-md'}>
                      <span className={'text-sm text-red-600'}>
                        Really Roll the risk for {getValues('date_t')}? You will be copying values
                        from {getValues('date_tmo')}.
                      </span>
                      <div className="flex items-center gap-2">
                        <SubmitButton
                          size="sm"
                          variant="default"
                          disabled={!isValid || isSubmitting}
                          loading={isSubmitting}
                        >
                          Confirm
                        </SubmitButton>
                        <Button
                          size="sm"
                          variant="destructive"
                          type="button"
                          onClick={() => setWantsToRollRisk(false)}
                        >
                          Cancel
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <Button
                        size="sm"
                        variant="default"
                        type="button"
                        disabled={!isValid || isSubmitting}
                        onClick={() => setWantsToRollRisk(true)}
                      >
                        Roll Risk
                      </Button>
                      <Button
                        size="sm"
                        variant="destructive"
                        type="button"
                        onClick={() => onOpenChange?.(false)}
                      >
                        Cancel
                      </Button>
                    </>
                  )}
                </div>
              </div>
            )
          }}
        </RollRiskForm>
      </DialogContent>
    </Dialog>
  )
}
